<template>
  <div>

<b-container>
  <select id="officeT" class="dropDown60px" @change="goFunction()" style="z-index:1;">
    <option value="general">General FAQ</option>
    <option value="mybijulee">FAQ About My Bijulee App</option>
  </select>
</b-container>

</div>
</template>
<script>
export default
 {

  methods: {
    goFunction()
    {
      var ofc=document.getElementById('officeT').value;
    //  alert("Office::"+ofc);
      this.goto(ofc);
    },

  goto(refName) {
  //   alert(refName);
     var element=document.getElementById(refName);
     element.scrollIntoView({  behavior: 'smooth', block: 'start', inline: 'start'  });

   }
  }
}
</script>
<style scoped="true">
.custom-row {
  margin-right: 0;
  margin-left: 0;
  height:50px;
}

.btn-block{
  height:100%;
  width:100% !important;
  text-align: left;
  font-size: 0.9rem;
  font-weight: 500;
  letter-spacing: 0.5px;
  border:none;
  border-bottom:1px solid;

}


.btn-color{
  color: #616161    ;
  background-color: #ffff;
  border-color: #e0e0e0 ;
  transition:0.3s;

 }
.btn-color:hover
{
  color: #ffff;
  background-color: #0277bd       ;
  border-color: #0277bd       ;
}
.btn-color-active
{
  color: #ffff;
  background-color: #0288d1     ;
  border-color: #0288d1     ;
  box-shadow: none;
}

.side-n{
box-shadow: 0 -2px 15px 0 rgba(0, 0, 0, 0.2), 0 10px 10px 0 rgba(0, 0, 0, 0.19);
width:100%;

}
.container,.col
{
  padding-left:0;
  padding-right: 0;
}
@media (max-width: 768px) {
  /* .dropDown60px{
    margin-right: 60px;
  } */
  }
</style>
